/** import package [start] */
import { useRoutes, RouteObject, Navigate } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
/** import package [end] */

/** import custom dependency [start] */
import './index.css';
import './style/custom-responsive.css';
import './style/custom.css';
import './style/username.css';
import './style/toggle.css';
import './style/artifact.css';
import './style/nodeLanding.css';
import AuthWrapper from './wrappers/AuthWrapper';
import { prefixPath } from './utils/helpers';
import MainLayout from './layouts/MainLayout';
/** import custom dependency [end] */

/** import pages [start] */
import EndpointDetailsPage from './pages/endpointDetails';
import PurchaseNode from './pages/purchaseNode';
import CreateNetworkPage from './pages/createNetwork';
import CreateStakingNetworkPage from './pages/createStakingNetwork';
import NetworkDetailsPage from './pages/viewNetwork';
import AddNodePage from './pages/addNode/AddNode';
import AddStakingNodePage from './pages/addStakingNode/AddNode';
/** import pages [end] */

/** routes [start] */
const routes: RouteObject[] = [
    {
        element: <AuthWrapper />,
        children: [
            {
                path: prefixPath('/'),
                element: <MainLayout />,
                children: [
                    {
                        path: '',
                        element: <Navigate to={prefixPath('/nodes/full/purchase')} replace />,
                    },
                    {
                        path: prefixPath('/endpoints/:id'),
                        element: <EndpointDetailsPage />,
                    },
                    {
                        path: prefixPath('/nodes/full/purchase'),
                        element: <PurchaseNode purchaseType='dedicated-node' />,
                    },
                    {
                        path: prefixPath('/nodes/validator/purchase'),
                        element: <PurchaseNode purchaseType='staking-node' />,
                    },
                    {
                        path: prefixPath('/nodes/full/deploy'),
                        element: <CreateNetworkPage />,
                    },
                    {
                        path: prefixPath('/nodes/validator/deploy'),
                        element: <CreateStakingNetworkPage />,
                    },
                    {
                        path: prefixPath('/nodes/full/:id'),
                        element: <NetworkDetailsPage />,
                    },
                    {
                        path: prefixPath('/nodes/validator/:id'),
                        element: <NetworkDetailsPage />,
                    },
                    {
                        path: prefixPath('/nodes/full/:id/add'),
                        element: <AddNodePage />,
                    },
                    // {
                    //     path: prefixPath('/nodes/validator/:id/add'),
                    //     element: <AddStakingNodePage />,
                    // },
                    {
                        path: '*',
                        element: <Navigate to={prefixPath('/nodes/full/purchase')} replace />,
                    },
                ],
            },
        ],
    },
];
/** routes [end] */

/**
 * Component of main application DOM along with load config file functionality
 * @returns
 */
const App = () => {
    const element = useRoutes(routes);
    return element;
};

export default App;
